"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var splitUrlPiece_1 = __importDefault(require("./splitUrlPiece"));
var splitHashParams = lodash_1.default.partial(splitUrlPiece_1.default, '#');
exports.default = splitHashParams;
